import Translatable from '../translatable_text/Translatable';

function Intro() {
  return (
    <section className="page-intro position-re">
      <div className="w-full rest">
        <div className="flex justify-end">
          <div className="sm:w-9/12">
            <div className="img to-up fit-img">
              <img src="/light/assets/imgs/wide-bg/wide-bg8.webp" alt="img" />
            </div>
          </div>
        </div>
      </div>
      <div className="max-w-7xl mx-auto px-4 section-padding">
        <div className="grid grid-cols-12 gap-6">
          <div className="col-span-12 lg:col-span-5">
            <h6 className="sub-title main-color"><Translatable>About GCAD</Translatable></h6>
          </div>
          <div className="col-span-12 lg:col-span-7">
            <div className="text">
              <h4>
                <Translatable>
                  A Saudi company working to provide services to logistics sector service providers as a technical consultant through its digital lab
                </Translatable>
              </h4>
            </div>
          </div>
        </div>
      </div>
      <div className="line-overlay">
        <svg
          viewBox="0 0 1728 1101"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M-43 773.821C160.86 662.526 451.312 637.01 610.111 733.104C768.91 829.197 932.595 1062.9 602.782 1098.75C272.969 1134.6 676.888 25.4306 1852 1"
            style={{ strokeDasharray: 3246.53 }}
          ></path>
        </svg>
      </div>
    </section>
  );
}

export default Intro;
